import Icon from "components/atoms/Icon";
import HStack from "components/atoms/stack/HStack";
import { useEffect, useRef, useState } from "react";
import { layoutStyles } from "styles/layout";
import Button from "theme/Button";
import { colorList } from "utils/colors";
import { StyleSheet } from "react-native";
import Input from "theme/Input";

const InputPlusMin = ({ min = 0, value = 1, onChange }) => {

    const inputRef = useRef( undefined )
    const [ amount, setAmount ] = useState( value );

    useEffect(() => {
        if( inputRef.current ) {
            inputRef.current.value = amount;
        }

        if( onChange ) {
            onChange( amount );
        }
    }, [ amount ]);

    return (
        <HStack
            style={styles.hStackJustifyContentCenter}
            itemStyle={{ 
                ...layoutStyles.flexUnset,
                alignItems: 'center',
            }}>

            <Button
                disabled={ amount <= min }
                onPress={ () => {
                    if( amount > min ) {
                        setAmount( amount - 1 );
                    }
                }}
                icon={(
                    <Icon
                        name="minus"
                        color={colorList.WHITE.primary}
                    />
                )}
            />

            <Input 
                key={`input-${amount}`}
                ref={ inputRef }
                containerStyle={[ layoutStyles.flexOne, styles.upInputContainer ]}
                style={ styles.upInput }
                defaultValue={ amount } 
                disabled={ true } 
            />

            <Button
                onPress={ () => {
                    setAmount( amount + 1 );
                }}
                icon={(
                    <Icon
                        name="plus"
                        color={colorList.WHITE.primary}
                    />
                )}
            />
        </HStack>
    )
}

const styles = StyleSheet.create({
	hStackJustifyContentCenter: {
		justifyContent: 'center',
	},
    upContainer: {
        marginTop: 8,
        alignItems: 'center',
    },

    upInputContainer: {
        minWidth: 50
    },

    upInput: {
        width: 'auto',
        flex: 1,
        textAlign: 'center',
        height: 'auto'
    }
})

export default InputPlusMin;
